import React from "react";
import styles from "./store-management.module.scss";

import CustomTabs from "../../commons/components/CustomTabs";
import { useNavigate } from "react-router-dom";
import { routers } from "../../commons/constants/routers";
import StoreOffical from "./StoreOfficial";
import StorePending from "./StorePending";
import StoreRejected from "./StoreRejected";
import PrimaryButton from "../../commons/components/PrimaryButton/PrimaryButton";
import "./store-management-styles.scss";
import { STORETAB } from "./StoreTypeTabs";

interface Props {
  activeTypeTab: string;
  activeTab: string;
  onChange: (key: string) => void;
}

const StoreTabs: React.FC<Props> = ({ activeTypeTab, activeTab, onChange }) => {
  const Tabs = [
    { title: "Official Store", key: STORETAB.OFFICIAL.toString(), children: <div></div> },
    { title: "Pending Store", key: STORETAB.PENDING.toString(), children: <div></div> },
    { title: "Rejected Store", key: STORETAB.REJECTED.toString(), children: <div></div> },
  ];

  return (
    <div className={styles.wrapper}>
      <CustomTabs
        tabStyle={styles.customTab}
        className={"storeList__tabProduct"}
        activeTab={activeTab}
        onChange={onChange}
        tabs={Tabs}
      >
        <div className={styles.tabContent}>
          {activeTab === STORETAB.OFFICIAL.toString() && (
            <StoreOffical activeTypeTab={activeTypeTab} activeTab={activeTab} />
          )}
          {activeTab === STORETAB.PENDING.toString() && (
            <StorePending activeTab={activeTab} activeTypeTab={activeTypeTab} />
          )}

          {activeTab === STORETAB.REJECTED.toString() && (
            <StoreRejected activeTab={activeTab} activeTypeTab={activeTypeTab} />
          )}
        </div>
      </CustomTabs>
    </div>
  );
};

export default StoreTabs;
